import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Map of page routes to their IDs from the AppPages table
export const PAGE_IDS = {
  '/GmsUser': 1,        // User Management
  '/GmsRoleManagement': 82, // Role Management
  '/GmsEmployee': 2,    // Employee
  '/GmsAddEmployee': 83, // Add Employee
  '/GmsDepartment': 3,  // Department
  '/GmsDesignation': 4, // Designation
  '/GmsCompany': 5,     // Company
  '/GmsBranch': 6,      // Branch
  '/GmsBusiness': 7,    // Business
  '/GmsLeaveType': 8,   // Leave Type
  '/Dashboard': 9,      // Dashboard
  '/GmsEmployeeLeave': 10, // Employee Leave
  '/GmsEmployeeLeaveCredit': 11, // Employee Leave Credit
  '/GmsSalaryAdvance': 12, // Salary Advance
  '/GmsLeaveCalculator': 13, // Leave Calculator
  '/GmsAbsentDays': 14, // Absent Days
  '/GmsPayrollProcessing': 15, // Payroll Processing
  '/GmsSalaryAdvanceTransactionReport': 16, // Salary Advance Transaction Report
  '/GmsPayrollHistoryReport': 17, // Payroll History Report
  '/GmsPayrollDetailsHistoryReport': 18, // Payroll Details History Report
  '/GmsActivityManagement': 19, // Activity Management
  '/GmsActivityUpdated': 28, // Activity Configuration
  '/GmsProductManagement': 20, // Product Management
  '/GmsAddProduct': 80, // Add Product
  '/GmsDaybook': 21, // Daybook Management
  '/GmsAddDaybook': 89, // Add Daybook Entry
  '/GmsSalesbook': 22, // Salesbook Management
  '/GmsExpiringDocuments': 23, // Expiring Documents
  '/GmsNotifications': 43, // All Notifications
  '/GmsGroup': 24, // Group Management
  '/GmsService': 25, // Service Management
  '/GmsSalaryRevision': 26, // Salary Revision
  '/GmsAnnualLeaveCredit': 27, // Annual Leave Credit Processing
  '/GmsCustomer': 29, // Customer Management
  '/GmsRoom': 30, // Room Management
  '/GmsEquipment': 31, // Equipment Management
  '/GmsBooking': 32, // Booking Management
  '/GmsAddBooking': 73, // Add Booking
  '/GmsTax': 33, // Tax Management
  '/GmsSpaCategory': 34, // Spa Category Management
  '/GmsSpaSubCategory': 35, // Spa Sub Category Management
  '/GmsSpaService': 36, // Spa Service Management
  '/GmsSpaPackages': 37, // Spa Packages Management
  '/GmsSpaPackageSeries': 40, // Spa Packages Series Management
  '/GmsSpaCalendar': 41, // Spa Calendar
  '/GmsMembership': 42, // Membership Management
  '/GmsSpaEmployeeDashboard': 44, // Spa Employee Dashboard
  '/GmsSupplier': 48, // Supplier Management
  '/GmsSupplierCategory': 57, // Supplier Category Management
  '/GmsPurchaseOrder': 56, // Purchase Order Management
  '/GmsAddPurchaseOrder': 77, // Add Purchase Order
  '/GmsPurchase': 49, // Purchase Management
  '/GmsAddPurchase': 78, // Add Purchase
  '/GmsStockReport': 50, // Stock Report
  '/GmsPriceCatalog': 84, // Price Catalog
  '/GmsSpaManagerFinanceDashboard': 45, // Spa Manager & Finance Dashboard
  '/GmsAdminDashboard': 9, // Admin Dashboard (using Dashboard page ID since old dashboard is no longer used)
  '/GmsBilling': 38, // Billing Management
  '/GmsInvoiceReport': 39, // Invoice Report
  '/GmsInvoiceReport': 39, // Invoice Report
  '/GmsBookingReport': 46, // Booking Report
  '/GmsEmployeeReport': 47, // Employee Report
  '/GmsStockLockManagement': 53, // Stock Lock Management
  '/GmsDailySummary': 54, // Daily Summary Report
  '/GmsDailyClosing': 59, // Day Closing (X Report)
  '/GmsSource': 64, // Source Management
  '/GmsCostHead': 65, // Cost Head Management
  '/GmsOtherPayee': 66, // Other Payee Management
  '/GmsBank': 62, // Bank
  '/GmsBankAccount': 63, // Bank Account
  '/GmsPettyCashReceipts': 67, // Petty Cash Receipts
  '/GmsPettyCashPayments': 68, // Petty Cash Payments
  '/GmsPettyCashReport': 79, // Petty Cash Report (Combined Receipts and Payments)
  // '/GmsPettyCashReceiptsList': 69, // Petty Cash Receipts List (Deprecated - use /GmsPettyCashReport)
  '/GmsPettyCashPaymentsList': 70, // Petty Cash Payments List (Deprecated - use /GmsPettyCashReport)
  '/GmsSourceBasedReport': 71, // Source Based Customer Count and Revenue Report
  '/GmsCustomerList': 72, // Customer List
  '/GmsAddReceipt': 74, // Add Receipt
  '/GmsCashDeposit': 61, // Cash Deposit
  '/GmsAddCashDeposit': 76, // Add Cash Deposit
  '/GmsBillingList': 75, // Invoice List
  '/GmsCustomerReceipts': 58, // Customer Receipts (Receipts List)
  '/GmsZReport': 60, // Z Report
  '/GmsStockTransfer': 51, // Stock Transfer
  '/GmsReceiveStockTransfer': 52, // Receive Stock Transfer
  '/GmsDailyAttendance': 81, // Daily Attendance
  '/GmsRestaurantTable': 85, // Restaurant Table Management
  '/GmsRestaurantBookingList': 86, // Restaurant Booking List
  '/GmsTaxInvoiceReport': 88, // Tax Invoice Report
  '/GmsGiftCard': 90, // Gift Card Configuration
  '/GmsBilledServicesReport': 91, // Pending Billed Services Report
  '/GmsMessageTemplate': 92, // Message Template Configuration
  '/GmsCustomerSegregationReport': 93, // Customer Segregation Report
  '/GmsCampaign': 94, // Campaign Management
  '/GmsCampaignReport': 95, // Campaign Report
  '/GmsMaintenanceTickets': 96, // Maintenance Tickets
};


export const getUserPermissions = async () => {
  try {
    // Check if user is authenticated
    const isAuthenticated = localStorage.getItem("isAuthenticated");
    const token = localStorage.getItem("token");

    if (!isAuthenticated || !token) {
      throw new Error("User not logged in");
    }

    // First get all available pages
    const pagesResponse = await axios.get(`${BASE_URL}/api/Permission/pages`, {
      headers: getAuthHeader(),
    });
    const allPages = pagesResponse.data;

    // Get the user data from various possible storage locations
    let userId = localStorage.getItem("userId"); // Direct userId storage

    if (!userId) {
      // Try to get from user object
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      userId = user.user_Id || user.userId || user.user_UserName; // Include username as fallback

      // If still not found, try authUser
      if (!userId) {
        const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
        userId = authUser.userId || authUser.user_Id;
      }
    }

    if (!userId) {
      // As a last resort, try to get the username from the user object
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      userId = user.user_UserName;

      if (!userId) {
        throw new Error("User ID not found");
      }
    }

    // Note: Admin users will still be restricted by their specific permissions
    // This ensures consistent behavior where all users are subject to permission checks

    // Get user's specific permissions
    const permissionsResponse = await axios.get(`${BASE_URL}/api/Permission/user/${userId}`, {
      headers: getAuthHeader(),
    });

    return permissionsResponse.data || [];
  } catch (error) {
    throw error;
  }
};

export const hasPagePermission = (permissions, pageRoute) => {
  const pageId = PAGE_IDS[pageRoute];

  if (!pageId) {
    return false;
  }

  // Check if user has specific permission for this page
  const permission = permissions.find(p => p.permission_Page_Id === pageId);

  return permission ? permission.permission_View : false;
};

export const hasEditPermission = (permissions, pageRoute) => {
  const pageId = PAGE_IDS[pageRoute];
  if (!pageId) return false;

  const permission = permissions.find(p => p.permission_Page_Id === pageId);
  return permission ? permission.permission_Edit : false;
};

export const hasDeletePermission = (permissions, pageRoute) => {
  const pageId = PAGE_IDS[pageRoute];
  if (!pageId) return false;

  const permission = permissions.find(p => p.permission_Page_Id === pageId);
  return permission ? permission.permission_Delete : false;
};

export const hasApprovePermission = (permissions, pageRoute) => {
  const pageId = PAGE_IDS[pageRoute];
  if (!pageId) return false;

  const permission = permissions.find(p => p.permission_Page_Id === pageId);
  return permission ? permission.permission_Approve > 0 : false;
};

// Check if user is admin
export const isUserAdmin = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    return authUser.isAdmin === true;
  } catch (error) {
    return false;
  }
};

// Enhanced permission functions with admin override
export const hasPagePermissionWithAdmin = (permissions, pageRoute) => {
  if (isUserAdmin()) return true;
  return hasPagePermission(permissions, pageRoute);
};

export const hasEditPermissionWithAdmin = (permissions, pageRoute) => {
  if (isUserAdmin()) return true;
  return hasEditPermission(permissions, pageRoute);
};

export const hasDeletePermissionWithAdmin = (permissions, pageRoute) => {
  if (isUserAdmin()) return true;
  return hasDeletePermission(permissions, pageRoute);
};

export const hasApprovePermissionWithAdmin = (permissions, pageRoute) => {
  if (isUserAdmin()) return true;
  return hasApprovePermission(permissions, pageRoute);
};

// Granular permission functions for specific use cases
export const hasViewOnlyPermission = (permissions, pageRoute) => {
  if (isUserAdmin()) return false; // Admin has full access, not view-only
  const pageId = PAGE_IDS[pageRoute];
  if (!pageId) return false;

  const permission = permissions.find(p => p.permission_Page_Id === pageId);
  if (!permission) return false;

  // View-only means: has view permission but no edit/delete/approve permissions
  return permission.permission_View &&
    !permission.permission_Edit &&
    !permission.permission_Delete &&
    permission.permission_Approve <= 0;
};

export const hasEditOrHigherPermission = (permissions, pageRoute) => {
  if (isUserAdmin()) return true;
  const pageId = PAGE_IDS[pageRoute];
  if (!pageId) return false;

  const permission = permissions.find(p => p.permission_Page_Id === pageId);
  if (!permission) return false;

  return permission.permission_View &&
    (permission.permission_Edit || permission.permission_Delete || permission.permission_Approve > 0);
};

export const hasDeleteOrHigherPermission = (permissions, pageRoute) => {
  if (isUserAdmin()) return true;
  const pageId = PAGE_IDS[pageRoute];
  if (!pageId) return false;

  const permission = permissions.find(p => p.permission_Page_Id === pageId);
  if (!permission) return false;

  return permission.permission_View &&
    (permission.permission_Delete || permission.permission_Approve > 0);
};

export const checkPermission = (route) => {
  const PAGE_IDS = getPageIds();
  const permissions = getUserPermissions();

  // Map route to pageId
  const pageId = PAGE_IDS[route];

  // Check if user has permission for this page
  return permissions.some(p => p.permission_Page_Id === pageId);
}; 